import * as TYPES from './types';
export default {
    [TYPES.SET_INFO](state, payload) {
        state.info = { ...state.info, ...payload };
    }
};
